<template>
  <v-row no-gutters>
    <v-col cols="12" sm="4">
      <bar-order-panel></bar-order-panel>
    </v-col>
    <v-col cols="12" sm="8">
      <bar-product-gallery></bar-product-gallery>
    </v-col>
    <v-col cols="12" class="">
      <bar-order-submit @confirmOrder="$emit('confirmOrder')"></bar-order-submit>
    </v-col>
  </v-row>
</template>

<script>
import BarProductGallery from "@/modules/delivery/components-core/business/BarProductGallery/BarProductGallery.vue";
import BarOrderPanel from "@/modules/delivery/components-core/business/BarOrderPanel/BarOrderPanel.vue";
import BarOrderSubmit from "@/modules/delivery/components-core/business/BarOrderSubmit/BarOrderSubmit.vue";

export default {
  name: "BarOrder",
  components: {BarOrderSubmit, BarOrderPanel, BarProductGallery}
}
</script>

<style scoped>

</style>
